import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ApiError, tinctApi } from '../../api';
import { CustomCodeScope, customCodesQueryKey, invalidatePackagedPreviews } from './custom-codes-query-key';

export type DeleteCustomCodeParams = {
  scope: CustomCodeScope;
  codeId: string;
};

export const deleteCustomCode = async (
  params: DeleteCustomCodeParams,
): Promise<void> => {
  return await tinctApi.customCodes.deleteCustomCode(
    params.scope,
    params.codeId,
  );
};

export const useDeleteCustomCode = (
  options?: Omit<
    UseMutationOptions<void, ApiError, DeleteCustomCodeParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCustomCode,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: customCodesQueryKey(args[1].scope),
      });
      invalidatePackagedPreviews(queryClient);
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
